import React from 'react'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import './style.css'

const InfoItem = ({ icon, labelKey, value, className = '' }) => {
    const { t } = useTranslation()

    return (
        <div className={`info-item ${className}`}>
            <Icon icon={icon} className="info-item-icon" />
            <div className="info-item-content">
                <div className="info-item-label">{t(labelKey)}</div>
                <div className="info-item-value">{value}</div>
            </div>
        </div>
    )
}

export default InfoItem

